var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50004 17.3334C4.12767 17.3334 0.583374 13.6025 0.583374 9.00002C0.583374 4.39752 4.12767 0.666687 8.50004 0.666687C12.8724 0.666687 16.4167 4.39752 16.4167 9.00002C16.4167 13.6025 12.8724 17.3334 8.50004 17.3334ZM8.50004 15.6667C10.1797 15.6667 11.7907 14.9643 12.9784 13.7141C14.1661 12.4638 14.8334 10.7681 14.8334 9.00002C14.8334 7.23191 14.1661 5.53622 12.9784 4.28598C11.7907 3.03573 10.1797 2.33335 8.50004 2.33335C6.82034 2.33335 5.20943 3.03573 4.0217 4.28598C2.83397 5.53622 2.16671 7.23191 2.16671 9.00002C2.16671 10.7681 2.83397 12.4638 4.0217 13.7141C5.20943 14.9643 6.82034 15.6667 8.50004 15.6667V15.6667ZM7.71075 12.3334L4.35171 8.79752L5.47112 7.61919L7.71075 9.97669L12.1884 5.26252L13.3086 6.44085L7.71075 12.3334Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon3);
export default __webpack_public_path__ + "static/media/dashboard-icon-3.60d7fd0e845c2af150aede00bc0e7560.svg";
export { ForwardRef as ReactComponent };